import React, { useState, useRef, useEffect } from "react";
import { producaov2 as api } from "../../../../../services/apis";
import { Button, Form, Input } from "semantic-ui-react";
import * as yup from "yup";
import { toast } from "react-toastify";

import { Container, Content, Title } from "./styles";

import swal from "sweetalert";
import { Link, withRouter } from "react-router-dom";
import AdminMenu from "../../../../../components/Admin/MenuDetalhes/AdminMenu";
import Dropzone from "../../../../../components/Admin/Dropzone";
import { isAuthAdmin } from "../../../../../services/auth";

const CriarCertificado = (props) => {
  const [selectedFile, setSelectedFile] = useState("");
  const description = useRef("");
  const [certificado, setCertificado] = useState({
    id_curso: "",
    url_image: "",
  });

  useEffect(() => {
    loadAuth();
  }, []);

  const loadAuth = async () => {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
  };

  const uploadImage = async () => {
    try {
      const inputData = new FormData();

      inputData.append("file", selectedFile);
      inputData.append("path", "imagens-voitto/certificados_template/cursos");

      const response = await api.post("/upload", inputData);
      const { url } = response.data;

      setCertificado({ ...certificado, url_image: url });

      toast.success("A operação foi concluida com sucesso!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } catch (err) {
      toast.error("A operação falhou, verifique o arquivo e tente novamente", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  const create = async () => {
    await setCertificado({ ...certificado, description: description.current });

    const certificadoValidation = await yup.object().shape({
      id_curso: yup
        .number("Necessário que informe o id do curso")
        .required("Necessário que informe a id do curso"),
      url_image: yup
        .string("Necessário que informe a imagem")
        .required("Necessário que informe a imagem"),
    });

    const payload = {
      id_curso: parseInt(certificado.id_curso),
      url_image: certificado.url_image,
    };

    try {
      await certificadoValidation.validate(payload, { abortEarly: true });
      api
        .post(`/certificados/curso/templates`, payload)
        .then((res) => {
          let array = {
            local: "ead/certificadoCurso",
            texto: `criou os modelos de certificado curso de id=${res.data.id}`,
          };
          api.post("system_logs", { acao: JSON.stringify(array) });
          props.history.push("/admin/ead/certificados/cursos");
        })
        .catch((err) => {
          swal(
            "Não foi possível salvar o Certificado",
            err,
            "Verifique também se o curso está correto"
          ).then((res) => props.history.push("/admin"));
        });
    } catch (err) {
      if (err instanceof yup.ValidationError) {
        swal("Erro!", `${err}`, "error");
        return;
      }
    }
  };

  return (
    <>
      <Container>
        <AdminMenu />

        <Content>
          <Title>Criar Certificados</Title>

          <Form>
            <Form.Group widths="equal">
              <Form.Field
                control={Input}
                label="Id do Curso"
                placeholder="Id do curso"
                value={certificado.id_curso}
                onChange={(e) => {
                  setCertificado({ ...certificado, id_curso: e.target.value });
                }}
              />
            </Form.Group>

            <Form.Group>
              <Form.Field>
                <Dropzone onFileUploaded={setSelectedFile} />
              </Form.Field>
            </Form.Group>
            <Form.Field>
              <Button color="primary" onClick={() => uploadImage()}>
                Subir imagem
              </Button>
            </Form.Field>
            <Form.Group>
              <Form.Field control={Button} onClick={() => create()}>
                Criar
              </Form.Field>
              <Link to="/admin/ead/certificados/cursos">
                <Button color="secondary">Cancelar</Button>
              </Link>
            </Form.Group>
          </Form>
        </Content>
      </Container>
    </>
  );
};

export default withRouter(CriarCertificado);
